
import React from "react";
import PreviewBlocks from "./PrescriptorPreview";

const PrescriptorEntriesList = ({
  entries = [],
  onAddEntry,
  onSelectEntry,
  onDeleteEntry,
  deletingEntryId = "",
  canDeleteEntry,
  title = "Entries in this prescription",
  addLabel = "+ Entry",
}) => {
  const savedEntries = (entries || []).filter((entry) => !entry.isDraft);

  return (
    <div className="np-preview" style={{ marginTop: 12 }}>
      <div
        className="np-row"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <h4 className="np-section-title" style={{ marginBottom: 0 }}>
          {title}
        </h4>
        <button className="np-btn-soft" onClick={onAddEntry}>
          {addLabel}
        </button>
      </div>
      <div className="np-preview-list">
        {savedEntries.map((entry) => {
          const rawNote = entry.note || "";
          const entryNote = rawNote
            .split('\n')
            .filter((l) => !String(l || "").trim().startsWith("Interaction:"))
            .join('\n')
            .trim();
          const canDelete =
            typeof canDeleteEntry === "function" ? canDeleteEntry(entry) : true;

          return (
            <div
              className="np-entry-preview-card np-entry-preview-list"
              style={{ padding: 0, position: "relative" }}
              key={entry.id}
            >
              <button
                className="np-entry-preview-edit"
                onClick={() => onSelectEntry?.(entry.id)}
                title="Edit entry"
                aria-label="Edit entry"
              >
                ✎
              </button>
              <button
                className={`np-entry-preview-edit np-entry-preview-delete-btn${deletingEntryId === String(entry.id) ? " is-loading" : ""}`}
                onClick={(event) => {
                  event.stopPropagation();
                  onDeleteEntry?.(entry.id);
                }}
                title="Delete entry"
                aria-label="Delete entry"
                disabled={deletingEntryId === String(entry.id) || !canDelete}
              >
                {deletingEntryId === String(entry.id) ? "..." : "×"}
              </button>
              <PreviewBlocks blocks={entry.blocks} entryNote={entryNote} allowUntitled={false} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PrescriptorEntriesList;
